<template>
	<div class="parkDetail">
    <div class="oneline">
      <div class="oneArea">
        <div class="title">园区展览图: </div>
        <div class="imgArea">
          <img :src="list.url" alt="" v-for="(list,index) in zhanlanFileList">
        </div>
      </div>
      <div class="oneArea">
        <div class="title">园区小头像: </div>
        <div class="imgArea">
          <span v-if="!touxiangFileList||touxiangFileList.length==0">无</span>
          <img :src="list.url" alt="" v-for="(list,index) in touxiangFileList">
        </div>
      </div>
    </div>
    <div class="oneline">
      <div class="oneItem">
        <div class="label">   园区/场地名称:</div>
        <div class="text">{{parkName}}</div>
      </div>
      <div class="oneItem">
        <div class="label">   园区图标在地图上层级排序（数字越大越靠上）:</div>
        <div class="text">{{parkMapSequence}}</div>
      </div>
      <div class="oneItem">
        <div class="label">  联系人姓名:</div>
        <div class="text">{{contactName}}</div>

      </div>
      <div class="oneItem">
        <div class="label">联系人手机:</div>
        <div class="text">{{contactPhone}}</div>
      </div>
      <div class="oneItem">
        <div class="label">  经度:</div>
        <div class="text">{{parkLongitude}}</div>
      </div>
      <div class="oneItem">
        <div class="label"> 纬度:</div>
        <div class="text">{{parkLatitude}}</div>
      </div>
      <div class="oneItem">
        <div class="label">    园区/场地地址:</div>
        <div class="text"><span class="">{{proviceText}}</span>
        <span class="">{{cityText}}</span>
        <span class="">{{distText}}</span>
        <span class="">{{addressDetail}}</span></div>

      </div>
      <div class="oneItem">
        <div class="label">园区简介:</div>
        <div class="text">{{parkIntro}}</div>
        <div class="text" v-if="!parkIntro">无</div>
      </div>

    </div>
    <div class="oneline">
      <div class="label">园区标签: </div>
      <div class="rightInput">
        <tagSelect :value="storeTagStr" :type="'park'" @clickItem="getTag" :showArea="'detail'"></tagSelect>
      </div>
    </div>
    <div class="oneline">
      <div class="label">园区地图上显示图标:</div>
      <div class="rightInput">
        <tagSelect :value="parkMapIconId"  :type="'map_park'"  :showArea="'detail'"></tagSelect>
      </div>
    </div>
    <div class="oneLine">
      <div class="rightInput">
        <div id="mapContainer"></div>
      </div>
    </div>

	</div>
</template>

<script>
	import {json,wordData,utils} from '@/common/common.js'
	import { ajaxPost,api } from '@/common/request.js'
  import addressSelect from '@/components/addressSelect'
  // import tagSelect from '@/components/tagSelect'

  import AMap from 'AMap'
  // import {      ajaxApp} from '@/common/request_app.js'
	export default {
		name: 'adminIndex',
		data() {
			return {

        dialogImageUrl: '',
        dialogVisible: false,
        parkName:'',
        contactName:'',
        contactPhone:'',
        parkIntro :'',
        parkLongitude :'',
        parkLatitude :'',
        parkMapIcon: [],
        parkMapIconId: '',
        storeTagStr:[],
        storeTagArr:[],
        imageType:'',//11101  园区头部图(即多图展示)  11201 园区方形小图（单张小头像）   11301 商家店面图  11401 品牌图111501 商品图
        uploadData:{},
        // multiImgInfoArr:[],//存储图片名字和其后台返回的id
        multiImgInfoArr_string:'',//存储图片名字和其后台返回的id
        smallAvatarImgInfoArr_string:'',//存储图片名字和其后台返回的id
        // ditu
        proviceText:"",
        cityText:'',
        distText:'',
        proviceId:"",
        cityId:'',
        distId:'',
        parkId:'',
        zhanlanFileList:[],
        touxiangFileList:[],


        // addressValue:'',
        addressDetail:'',//详细地址
        // addressOptions:[],
        props: {
          lazy: true,
          lazyLoad (node, resolve) {
            console.log(node)
            const { level }=node;
            let nodeId=node.value||0
            let arg={parentId:nodeId}
            ajaxPost('/globalRegionInfo/regionInfo', arg).then(function(res) {
                if (res.errorCode == 200) {
                  let lists=res.data||[{region_id:node.value+'mm',region_name:node.label}]
                  // let lists=res.data
                  let newArr=lists.map(function(item,index){
                    let buffer={
                      value:item.region_id,
                      label:item.region_name,
                      leaf:level>=2,
                    }
                    return buffer
                  })
                  resolve(newArr);
                }
            }, function(res) {
              // let newArr={
              //   value:"-",
              //   label:"-",
              //   leaf:level>=2,
              // }
              // resolve(newArr)
            })

          }
        }



			}
		},
		computed: {
			IMG_PREV(){
				return api.imgPrev
			},
      api(){
        return api
      },
      adminId() {
          return utils.getAdminId()
      },
		},
		components: {
      addressSelect
		},
		methods: {
      getTag(data){
        this.storeTagArr=data
      },
      getFileListFromRes(json,typrStr){
        let type=''
        if(typrStr=='zhanlan'){
          type='11101'
        }
        if(typrStr=='touxiang'){
          type='11201'
        }
        let result=[]
        let _this=this
        if(json&&utils.isJSON(json) ){
          let list=JSON.parse(json)
          list.forEach(function(item,index){
            let buffer={}
            // console.log(item.imageFiles)
            // if(item.imageFiles){
            //   let urlArr=item.imageFiles.split(",")
            //   console.log(urlArr)
            // }
            buffer.url=item.imageFiles?_this.IMG_PREV+item.imageFiles.split(",")[0]:""
            buffer.name='img'+item.imgId
            buffer.name='img'+item.imgId
            buffer.wwType=type
            buffer.wwId=item
            result.push(buffer)
          })
          console.log(result)

        }
        return result
      },
      changeAddress(data){
        // console.log(JSON.stringify(data))
        this.proviceId=data.proviceId
        this.proviceText=data.proviceText
        this.cityId=data.cityId
        this.cityText=data.cityText
        this.distId=data.distId
        this.distText=data.distText
      },
      // choseTag(list){
      //   list.isChosed=!list.isChosed
      // },
      // getTagList_park(){
      //   let _this=this
      //   console.log(arg)
      //   let arg={tagType:"park"}
      //   ajaxPost('/tag/tagList', arg).then(function(res) {
      //     if(res.errorCode==200){
      //       _this.list_tag_park=res.data.map(function(item,index){
      //         item.isChosed=false
      //         return item
      //       })

      //     }else{

      //     }
      //   }, function(res) {})
      // },
      initMap() {
        let _this=this
        let lng=_this.parkLongitude
        let lat=_this.parkLatitude
        let map = new AMap.Map('mapContainer', {
          center: [lng, lat],
          resizeEnable: true,
          zoom: 14,
          viewMode:'3D'//使用3D视图
        })
        AMap.plugin(['AMap.ToolBar', 'AMap.Scale'], function () {
          map.addControl(new AMap.ToolBar())
          map.addControl(new AMap.Scale())
        })
        let marker=''
        marker = new AMap.Marker({
            position: new AMap.LngLat(lng, lat),   // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
            // title: '北京'
        });
        // 将创建的点标记添加到已有的地图实例：
        map.add(marker);
      },
      getParam() {
        this.parkId = this.$route.params.parkId
      },
      getDetail() {
        let _this = this
        let args = {
          parkId: _this.parkId,
        }
        ajaxPost('/park/getParkInfo', args).then(function(res) {
          if (res.data) {
            let resData=res.data
            _this.contactPhone=resData.parkContactCellphone
            _this.contactName=resData.parkContactName
            _this.addressDetail=resData.addressString
            _this.parkIntro=resData.parkIntro
            _this.parkLatitude=resData.parkLatitude
            _this.parkLongitude=resData.parkLongitude
            
            _this.initMap()
            _this.parkMapSequence=resData.parkMapSequence||0
            _this.parkName=resData.parkName
            _this.cityId=resData.regionCityId
            _this.parkMapIconId=resData.mapPark
            _this.cityText=resData.regionCityString
            _this.distId=resData.regionDistrictId
            _this.distText=resData.regionDistrictString
            _this.proviceId=resData.regionProvinceId
            _this.proviceText=resData.regionProvinceString
            _this.storeTagStr=resData.storeTag
            // 图片 zhanlanFileList:[],        touxiangFileList:[],
            _this.zhanlanFileList=_this.getFileListFromRes(resData.storeBigPic,'zhanlan')
            _this.touxiangFileList=_this.getFileListFromRes(resData.storeSmallPic,'touxiang')
          }

        }, function(res) {})
      },
      // handleChangeAddress(value){//更改地址
      //   console.log("地址change")
      //   let nodesObj = this.$refs['cascader'].getCheckedNodes()
      //   // console.log(nodesObj)
      //   var valueArr=nodesObj[0].path
      //   var TextArr=nodesObj[0].pathLabels
      //   console.log(valueArr)
      //   console.log(TextArr)
      //   // proviceText
      //   this.proviceId=valueArr[0]
      //   this.cityId=valueArr[1]
      //   this.distId=valueArr[2]&&valueArr[2].length==6?valueArr[2]:''
      //   this.proviceText=TextArr[0]
      //   this.cityText=TextArr[1]
      //   this.distText=this.distId?TextArr[2]:''
      // },
			back(){
				this.$router.back()
			},
      exceedHandle(){
        alert("只允许上传一张")
      },
      handleRemove(file, fileList) {
        if(file.wwType=='11101'){
          console.log("删除的是多图")
          // this.multiImgInfoArr_string=this.computeImgIdArrToString(fileList)
          this.zhanlanFileList=fileList
        }
        if(file.wwType=='11201'){
          console.log("删除的是单图")
          this.touxiangFileList=fileList
          // this.smallAvatarImgInfoArr_string=this.computeImgIdArrToString(fileList)

        }
      },
      handlePictureCardPreview(file) {
        console.log(this.imageType)



        console.log("预览图片---")
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      addImgClick(type){//点击不同的图片上传按钮，设置imagetype及图片data
        console.log('点击上传按钮---'+type)
        if(type=='multi'){
           this.imageType=11101
           this.uploadData = {
               imageType: this.imageType,
               imageUserId: this.adminId,
           }
           // console.log(this.uploadData)
        }
        if(type=='smallAvatar'){
           this.imageType=11201
           this.uploadData = {
               imageType: this.imageType,
               imageUserId: this.adminId,
           }
           // console.log(this.uploadData)
        }
      },
      computeImgIdArrToString(fileList){
        let resultArr=[]
        for(var i=0;i<fileList.length;i++){
          let oneItem=fileList[i]
          let obj=oneItem.wwId
          console.log(obj)
          resultArr.push(obj)

        }
        console.log(resultArr)
        return resultArr
      },
      addImgSuccessHandle(res, file,fileList){//自动上传成功以后的操作
        console.log("上传图片成功---")
        console.log(this.imageType)
        console.log(file, fileList);
        if(res.errorCode==200){
          file.wwId=res.data
          file.wwType=this.imageType
          if(this.imageType=='11101'){
            this.zhanlanFileList=fileList
            // this.multiImgInfoArr_string=this.computeImgIdArrToString(fileList)
          }
          if(this.imageType=='11201'){
            this.touxiangFileList=fileList
            // this.smallAvatarImgInfoArr_string=this.computeImgIdArrToString(fileList)
          }
        }

      },

		},
		mounted() {
			let _this = this
      this.getParam()
      this.getDetail()
      // this.getTagList_park()
		},
		destroyed(){
		}
	}

</script>

<style scoped lang="scss">
	* {
		// outline: 1px solid blue;
	}
  .imgArea{ height: 150px;border:1px solid aaa;vertical-align: top;}
  .oneArea{
    display: inline-block; margin-right: 20px;;vertical-align: top;
    .title{font-weight: bold;}
    img{height: 150px;width: auto;margin-right: 20px;}
  }
  #mapContainer {width:900px; height: 600px;}
  .parkDetail{
    .title{padding:10px 0;}
    padding:10px;
    .oneItem{display: inline-block;margin-bottom: 10px;min-width: 33%;}
    .label{display: inline-block;padding:10px;border-radius: 2px;font-weight:bold ;}
    .text{display: inline-block;}
    .rightInput{display: inline-block;}
  }

</style>



// WEBPACK FOOTER //
// src/pages/park/detail.vue